import { loginSchema } from '@projetive-op/domain'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { type FormEvent, useState } from 'react'
import { z } from 'zod'

import { LogoOP } from '@/components/marca'
import { Button } from '@/components/ui/button'
import { Campo, Input, MensagemFormulario } from '@/components/ui/campo'
import { mensagemDeErro } from '@/lib/erros'
import { type ErrosFormulario, focarPrimeiroErro, validar } from '@/lib/formulario'
import { useTRPC } from '@/lib/trpc'

export const Route = createFileRoute('/login')({
  validateSearch: z.object({ redirect: z.string().optional() }),
  component: Login,
})

function Login() {
  const trpc = useTRPC()
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const { redirect } = Route.useSearch()
  const [erros, setErros] = useState<ErrosFormulario>({})

  const login = useMutation(
    trpc.auth.login.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({ queryKey: trpc.auth.me.queryKey() })
        await navigate({ to: redirect ?? '/gestao' })
      },
      onError: (e) => setErros({ _: mensagemDeErro(e) }),
    }),
  )

  const enviar = (ev: FormEvent<HTMLFormElement>) => {
    ev.preventDefault()
    const form = ev.currentTarget
    const r = validar(loginSchema, Object.fromEntries(new FormData(form)))
    if (r.erros) {
      setErros(r.erros)
      focarPrimeiroErro(form)
      return
    }
    setErros({})
    login.mutate(r.dados)
  }

  return (
    <main className="grid min-h-full place-items-center p-4">
      <form onSubmit={enviar} className="flex w-full max-w-sm flex-col gap-5 card p-8" noValidate>
        <div className="flex flex-col gap-4">
          <LogoOP tamanho="size-10" assinatura />
          <div>
            <h1 className="text-xl font-bold">Entrar na gestão</h1>
            <p className="text-sm text-fg-muted">
              Operadores entram pelo tablet do posto, com o PIN.
            </p>
          </div>
        </div>
        <Campo label="E-mail" erro={erros.email}>
          {(p) => (
            <Input {...p} name="email" type="email" autoComplete="username" autoFocus required />
          )}
        </Campo>
        <Campo label="Senha" erro={erros.senha}>
          {(p) => (
            <Input {...p} name="senha" type="password" autoComplete="current-password" required />
          )}
        </Campo>
        <MensagemFormulario erro={erros._} />
        <Button type="submit" carregando={login.isPending} className="mt-1">
          Entrar
        </Button>
      </form>
    </main>
  )
}
